import { Revela } from '../components/Revela';

const RECURSOS = [
  {
    numero: '01',
    detalhe: 'ESTUDE COM DIREÇÃO',
    titulo: 'Escolha o que precisa revisar.',
    texto:
      'Filtre as questões por disciplina e assunto. Organize a preparação a partir do conteúdo que você precisa dominar.',
  },
  {
    numero: '02',
    detalhe: 'VÁ ALÉM DO GABARITO',
    titulo: 'Entenda por que acertou ou errou.',
    texto:
      'Leia comentários com legislação, jurisprudência e doutrina. Entenda o acerto e o detalhe que torna as outras respostas incorretas.',
  },
  {
    numero: '03',
    detalhe: 'CONECTE O CONHECIMENTO',
    titulo: 'Estude a lei artigo por artigo.',
    texto:
      'Aprofunde o estudo com leis e normas comentadas artigo por artigo. A Legislação Comentada está incluída no módulo Enac.',
  },
];

export function ComoFunciona() {
  return (
    <section id="como-funciona" className="landing-secao recursos-secao">
      <Revela>
        <div className="secao-abertura">
          <span className="sobretitulo">DA QUESTÃO À REVISÃO</span>
          <h2>
            Questões, comentários e legislação.
            <br />
            <em>Um estudo conectado.</em>
          </h2>
          <p>
            Selecione uma disciplina, resolva as questões e revise os fundamentos das alternativas
            que geraram dúvida.
          </p>
        </div>
      </Revela>
      <div className="recursos-grade">
        {RECURSOS.map((recurso) => (
          <Revela key={recurso.numero}>
            <article className="recurso">
              <span className="recurso-numero">{recurso.numero}</span>
              <span className="sobretitulo">{recurso.detalhe}</span>
              <h3>{recurso.titulo}</h3>
              <p>{recurso.texto}</p>
            </article>
          </Revela>
        ))}
      </div>
    </section>
  );
}
